import Image from '@next/image';
import classNames from 'classnames';

import { MappedTrait } from 'types/MappedTrait';
import Picture from 'types/Picture';
import Typography from '@components/atoms/Typography';

import classes from './Traits.module.scss';

type Props = {
  traits: MappedTrait[];
  picture?: Picture;
};

const Traits = ({ traits, picture }: Props) => (
  <div className={classes.container}>
    {picture && (
      <div className={classes.traitImage}>
        <Image
          layout="fill"
          objectFit="contain"
          alt={`${picture.productName}-${picture.description}`}
          resolveConfig={{
            preset: 'p_main',
            description: picture.description,
            productName: picture.productName,
            extension: picture.extension,
            name: picture.baseName,
            width: picture.width,
            height: picture.height,
          }}
        />
      </div>
    )}
    <div className={classes.wrapper}>
      {traits.map((trait) => (
        <div key={trait.id}>
          <Typography className={classes.traitName} variant="h3" renderAs="div">
            {trait.name}
          </Typography>
          <div className={classes.traitValues}>
            {trait.traitValues.map((traitValue) => (
              <div key={traitValue.id} className={classes.traitValue}>
                <div className={classNames(classes.bar, { [classes.isSelected]: traitValue.isSelected })} />
                <Typography variant="h4" renderAs="div" wordBreak="break-word" withEllipsis>
                  {traitValue.value}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Traits;
